import { AfterViewInit, Component, Input,  OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {    ControlContainer, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {  SharedDataService }  from '../../all-services';
import { Question, SupplierAnswer}  from '../../all-models';
import { PafLabelDirective, }  from '../../all-directives';

@Component({
  selector: 'question-row',
  templateUrl: './question-row.component.html',
  styleUrls: ['./question-row.component.scss'],
    viewProviders: [
      { provide: ControlContainer, useExisting: NgForm }
    ]
})
export class QuestionRowComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() readonly:boolean = false;
  @Input() questionId?: number = null;
  @Input() question?: Question = null;
  @Input() visibleQuestions: Question[] = [];
  @Input() answers?: SupplierAnswer[] = [];
  @Input() labelBefore: boolean = true;
  @Input() questionLevel: number = 0;
  //@ViewChild('frmQuestion') frmQuestion:NgForm;

  get frmQuestion(): NgForm {
    return this.controlContainer as NgForm;
  } 
  
  get lblCod(): string {
    return this.question?.LblCod;
  }
  get name(): string {
    return 'questionRow' + this.question ? this.question.Cod : '';
  }

  get nameTrue():string {
    return this.name+'-true';
  }
  get nameFalse():string {
    return this.name+'-false';
  }
  

  get innerTrueHtml(): string {
    return this.question?.TrueHtml ||'';
  }
  
  public get trueQuestion(): Question | undefined {
    return this.question && this.allQuestions.find(q => q.Id == this.question.IdTrueQuestion && this.QuestionVisible(q.Id));
  }
  public get falseQuestion(): Question | undefined {
    return this.question && this.allQuestions.find(q => q.Id == this.question.IdFalseQuestion && this.QuestionVisible(q.Id));
  }

  public get trueQuestionEnabled(): boolean {
    return !!(this.trueQuestion  && this.value === true);
  }
  public get  falseQuestionEnabled(): boolean {
    return !!(this.falseQuestion  && this.value === false);
  }
  

  //true si la question suivante est la même quelle que soit la reponse
  public get onlyOneQuestionNext(): boolean {
    return !!(this.question && this.question.IdTrueQuestion &&  this.question.IdTrueQuestion==this.question.IdFalseQuestion);
  }

  public get showTrueQuestion():boolean{
    return !!(this.trueQuestionEnabled || this.onlyOneQuestionNext);
  }
  public get showFalseQuestion():boolean{
    return !!(this.falseQuestionEnabled && !this.onlyOneQuestionNext);
  }

  private allQuestions: Question[] = [];

  private pafLabels: PafLabelDirective=null;
  constructor(
    public sharedDatasSvc: SharedDataService,
    private route:ActivatedRoute,
      public controlContainer: ControlContainer) {
  }
  ngAfterViewInit(): void {
    if (this.frmQuestion) this.sharedDatasSvc.CanSave(this.frmQuestion,true);
  }
  ngOnInit(): void {
    this.pafLabels = new PafLabelDirective(this.sharedDatasSvc,this.route,null);
    this.pafLabels.labelsReloaded.subscribe(res=>{
      this.sharedDatasSvc.listsSvc.getQuestions()
        .subscribe((res:Question[]) => {
          this.allQuestions = res;
          this.refreshQuestions();
        });
    });
    this.pafLabels.reloadLibs();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question'] || changes['questionId']) 
     {
      this.refreshQuestions();
    }
  }

  get answer():SupplierAnswer{
    return this.answers?.find((answer:SupplierAnswer) => answer.QuestionId == this.question?.Id);
  }

  get value(): boolean {
    //let item: SupplierAnswer = this.answers?.find((answer:SupplierAnswer) => answer.QuestionId == this.question?.Id);
    let item = this.answer;
    if (!item || item.Answer == null){
      return null;
    } else {
      return (item.Answer==1);
    }
  }
  set value(val: boolean) {
    if (this.question && this.answers) {
      //let item: SupplierAnswer = this.answers?.find((answer:SupplierAnswer) => answer.QuestionId == this.question?.Id);
      let item = this.answer;
      let itemQuestion: Question = this.allQuestions.find(q=>q.Id==item.QuestionId);
      if (!item) return;
      let isChanged:  boolean = false;
      switch (val){
        case null:
          if (item.Answer!=null){
            item.Answer = null;
            isChanged = true;
          }
          break;
        case true:
          if (item.Answer!=1){
            item.Answer = 1;
            isChanged = (itemQuestion.IdFalseQuestion!=itemQuestion.IdTrueQuestion);
          }
          break;
        case false:
          if (item.Answer!=0){
            item.Answer = 0;
            isChanged = (itemQuestion.IdFalseQuestion!=itemQuestion.IdTrueQuestion);
          }
          break;
        }
        if (isChanged){
          this.resetNextAnswers(this.question.Id);
        }  
      }
  }

  private resetNextAnswers(currentQuestionId: number) : void {
    const currentQuestion: Question = this.allQuestions.find(q=>q.Id==currentQuestionId);
    if (!currentQuestion) return;
 this.answers?.filter(sa=>[currentQuestion.IdTrueQuestion,currentQuestion.IdFalseQuestion].some(i=> i== sa.QuestionId))
    .forEach(sa=>{
      sa.Answer=null;
      this.resetNextAnswers(sa.QuestionId);
    });
  }



  private refreshQuestions(): void {
    if (!this.question && this.questionId) {
      this.question = this.allQuestions.find(q => q.Id == this.questionId);
    }
    if (this.question) {
      this.questionId = this.question.Id;
      if (this.question.DefaultAnswer!=null){
        if (this.answer!=null && this.answer.Answer==null){
          this.value = (this.question.DefaultAnswer == 1);
        }
      }
    }
   }

  // offLabel():Observable<string>{
  //   if (this.labelBefore){
  //     return this.pafLabels.getLabel(this.lblCod);
  //   } else {
  //     return of("");
  //   }
  // }
  // onLabel():Observable<string>{
  //   if (!this.labelBefore){
  //     return this.pafLabels.getLabel(this.lblCod)
  //   } else {
  //     return of("");
  //   }
  // }

  QuestionVisible(questionId: number):boolean{
    return this.visibleQuestions.some(q=>q.Id==questionId);
  }

}
